<div class="h-full w-full mx-auto flex flex-col" [formGroup]="editForm">
  <div class="overflow-x-auto bg-base-100">
    <table class="table w-full text-sm">
      <thead class="bg-base-200">
        <tr class="h-[55px]">
          <th
            class="py-3 px-4 text-left cursor-pointer font-bold text-base text-primary"
            appSortable
            [sortable]="'display_name'"
            (sort)="onSort($event)"
          >
            <div class="flex items-center gap-1">
              <span>Organization</span>
              <div class="ml-2 flex items-center gap-1">
                <div
                  *ngIf="currentSortColumn === 'display_name' && currentSortDirection === 'asc'"
                  class="w-5 h-5"
                  style="
                    background: #b1b2b5ff;
                    mask: url('/icons/ri-sort-asc.svg') no-repeat center / contain;
                    -webkit-mask: url('/icons/ri-sort-asc.svg') no-repeat center / contain;
                  "
                ></div>
                <div
                  *ngIf="currentSortColumn === 'display_name' && currentSortDirection === 'desc'"
                  class="w-5 h-5"
                  style="
                    background: #b1b2b5ff;
                    mask: url('/icons/ri-sort-desc.svg') no-repeat center / contain;
                    -webkit-mask: url('/icons/ri-sort-desc.svg') no-repeat center / contain;
                  "
                ></div>
                <div
                  *ngIf="currentSortColumn !== 'display_name'"
                  class="w-5 h-5"
                  style="
                    background: #b1b2b5ff;
                    mask: url('/icons/ri-sort-desc.svg') no-repeat center / contain;
                    -webkit-mask: url('/icons/ri-sort-desc.svg') no-repeat center / contain;
                  "
                ></div>
              </div>
            </div>
          </th>
          <th class="py-3 px-4 text-left font-bold text-base text-primary relative">
            <div class="flex items-center">
              <span>Reportable-pathogen auto-approval</span>
              <span
                class="tooltip tooltip-bottom ml-1 before:max-w-xs before:whitespace-normal before:text-left before:text-white before:font-normal"
                data-tip="When enabled, analytical dataset access requests are auto-approved for files tagged with a reportable pathogen."
              >
                <fa-icon
                  [icon]="['far', 'circle-question']"
                  class="inline-block w-4 h-4 text-error cursor-help"
                ></fa-icon>
              </span>
            </div>
          </th>
          <th class="py-3 px-4 font-bold text-base text-primary">Actions</th>
        </tr>
      </thead>
      <tbody *ngIf="sortedOrganizations().length > 0; else emptyState">
        <tr
          *ngFor="let organization of sortedOrganizations()"
          class="h-[55px] even:bg-base-200"
          [class.opacity-60]="activeFilter === 'deleted'"
        >
          <td class="py-3 px-4 text-sm text-primary font-medium">
            <ng-container *ngIf="editingId !== organization.id; else editName">
              {{ organization.display_name }}
            </ng-container>
            <ng-template #editName>
              <input
                class="input input-bordered w-full h-10 min-h-10 px-3 text-sm rounded border-base-300 text-primary focus:outline-none focus:border-base-300"
                formControlName="display_name"
                (keyup.enter)="saveEdit()"
                (keyup.escape)="cancelEdit()"
              />
            </ng-template>
          </td>
          <td class="py-3 px-4 text-sm text-primary font-medium">
            <div class="flex items-center gap-3">
              <span class="text-sm text-primary">No</span>
              <label
                class="relative inline-flex items-center cursor-pointer"
                [class.cursor-not-allowed]="activeFilter === 'deleted'"
              >
                <input
                  type="checkbox"
                  [id]="'toggle-' + organization.id"
                  class="sr-only peer"
                  [checked]="organization.default_approve_analytical_dataset_requests ?? false"
                  [disabled]="activeFilter === 'deleted'"
                  (change)="onToggleDefaultApprove(organization)"
                />
                <div
                  class="w-9 h-5 bg-base-300 rounded-full transition-colors duration-300 peer-checked:bg-info"
                  [class.opacity-50]="activeFilter === 'deleted'"
                ></div>
                <span
                  class="absolute left-[2px] top-[2px] bg-base-100 rounded-full h-4 w-4 shadow transition-all duration-300 peer-checked:translate-x-4"
                  [class.opacity-50]="activeFilter === 'deleted'"
                ></span>
              </label>
              <span class="text-sm text-primary">Yes</span>
            </div>
          </td>
          <td class="py-3 px-4">
            <div class="flex items-center gap-2">
              <ng-container *ngIf="editingId !== organization.id; else editActions">
                <button
                  *ngIf="activeFilter !== 'deleted'"
                  class="cursor-pointer text-primary-focus hover:text-primary transition-colors"
                  (click)="beginEdit(organization)"
                  aria-label="Edit"
                >
                  <fa-icon [icon]="'edit'"></fa-icon>
                </button>
                <button
                  *ngIf="activeFilter !== 'deleted'"
                  class="tooltip tooltip-bottom cursor-pointer text-primary-focus hover:text-info transition-colors before:max-w-xs before:whitespace-normal before:text-white before:font-normal"
                  data-tip="Configure request guidelines"
                  (click)="onConfigureGuidelines(organization)"
                  aria-label="Configure request guidelines"
                >
                  <fa-icon [icon]="'clipboard'"></fa-icon>
                </button>
                <button
                  *ngIf="activeFilter !== 'deleted'"
                  class="cursor-pointer text-primary-focus hover:text-error transition-colors"
                  (click)="onDelete(organization)"
                  aria-label="Delete"
                >
                  <fa-icon [icon]="'trash'"></fa-icon>
                </button>
              </ng-container>
              <ng-template #editActions>
                <button
                  class="cursor-pointer text-primary-focus hover:text-info transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                  (click)="saveEdit()"
                  [disabled]="editForm.invalid"
                  aria-label="Save"
                >
                  <fa-icon [icon]="'check'"></fa-icon>
                </button>
                <button
                  class="cursor-pointer text-primary-focus hover:text-base-content/70 transition-colors"
                  (click)="cancelEdit()"
                  aria-label="Cancel"
                >
                  <fa-icon [icon]="'times'"></fa-icon>
                </button>
              </ng-template>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<ng-template #emptyState>
  <tr class="h-[55px]">
    <td colspan="3" class="py-3 px-4 text-center text-base-content/70">No organizations found</td>
  </tr>
</ng-template>
